export enum ResponseFormat {
  textarea = "textarea",
  checkbox = "checkbox",
  radiobutton = "radio-button",
  hybrid = "hybrid",
  calendar_widget = "calendar-widget",
  level_of_confidence = "level-of-confidence",
  stakeholder_cards = "stakeholder-cards",
  resource_links = "resource-links",
  group_of_pop_out_menus = "group_of_pop_out_menus",
}
